import { useAppSelector } from 'app/config/storeConfig/hooks';
import { getContractOptions } from 'entities/Contract';
import { getLoggedUserData } from '../../model/selectors/getLoggedUserData';
import { checkUserDataComplete } from '../helpers/checkUserDataComplete';
import { getGlobalSettings } from 'app/appState';

export const useCheckUserDataComplete = (): boolean => {
  const loggedUserData = useAppSelector(getLoggedUserData);
  const contractOptions = useAppSelector(getContractOptions);
  const globalSettings = useAppSelector(getGlobalSettings);

  return checkUserDataComplete(loggedUserData, contractOptions.accountType, globalSettings);
};
